export default __webpack_public_path__ + "static/media/logo_play.4e162656.svg";